document.addEventListener('DOMContentLoaded', function () {
    console.log('Bloques personalizados cargados en el frontend.');
});
